<!-- @format -->
@if (isSnackBarOpen) {
	<div
		id="pdp-snackbar"
		class="snackbar-overlay"
		aria-live="assertive">
		<homefield-icon
			class="close-btn"
			width="32px"
			height="32px"
			name="sign-cancel"
			(click)="closeMessage()"></homefield-icon>
		<div class="error-line-one hmf-align-items-center">
			<homefield-icon
				class="airball"
				width="32px"
				height="32px"
				name="alert-error-outlined"></homefield-icon>
			<span>{{ title }}</span>
		</div>
		<div class="error-line-2nd">{{ airballMessage$ | async }}</div>
	</div>
}
